export enum EntityTypes {
  Organization = 1,
  Company = 2,
  BusinessArea = 3,
  Task = 4,
}
